import React from "react";
import { TContainer } from "../../../components/Common/Table";
import SearchInput from "../../../components/Common/SearchInput";
import Modal from "../../../components/Common/Modal";
import CreateUser from "../CreateUser";
import useUserList from "./useUserList";
import { MainWrapper, StyledHeader } from "../../../components/styles";
import { Grid } from "@mui/material";
import CustomTable from "../../../components/Common/CustomTable";
import IModal from "../../../components/Common/StyledModal";
import UpdateUser from "../UpdateUser";
import DeleteModal from "../../../components/Common/DeleteModal/DeleteModal";

const UserList = () => {
  const {
    loading,
    userList,
    totalCount,
    pagination,
    handleChangeRowsPerPage,
    handleChangePage,
    handleOnChangeSearch,
    getUserList,
    openEditModal,
    closeOpenEditModal,
    showEditModal,
    handleUserDetails,
    userDetails,
    onSetUserId,
    closeDeleteModal,
    showDeleteModal,
    openDeleteModal,
    onHandleDelete,

  } = useUserList();

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    getUserList();
  };
  return (
    <MainWrapper>
      <TContainer>
        <Grid container justifyContent="space-between" mb={2}>
          <Grid
            xs={12}
            sm={6}
            lg={6}
            item
            justifyContent={{
              lg: "flex-start",
              xs: "space-between",
            }}
            display="flex"
            alignItems={"center"}
          >
            <StyledHeader>User Management</StyledHeader>
            <SearchInput onChange={handleOnChangeSearch} />
          </Grid>
          <Grid xs={12} sm={3} lg={2} item justifyContent="flex-end">
            <Modal
              title="Create User"
              open={open}
              handleOpen={handleOpen}
              handleClose={handleClose}
            >
              <CreateUser handleClose={handleClose} />
            </Modal>
          </Grid>
        </Grid>
        <CustomTable
          data={userList}
          loading={loading}
          tableHeader={[
            {
              name: "Name",
              key: "firstName",
              idx: 1,
            },
            {
              name: "Email",
              key: "email",
              idx: 2,
            },
            {
              name: "Phone Number",
              key: "Phone",
              idx: 3,
            },
            {
              name: "Address",
              key: "Address",
              idx: 4,
            },
            {
              name: "Role",
              key: "role",
              idx: 5,
            },
            {
              name: "Actions",
              key: "Actions",
              idx: 6,
            },
          ]}
          count={totalCount}
          rowsPerpage={pagination?.perPage}
          onPageChange={handleChangePage}
          page={pagination?.page - 1}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleOpenEditModal={handleUserDetails}
          onSetUserId={onSetUserId}
        />
      </TContainer>
      <IModal
        open={showEditModal}
        /// handleOpen={openEditModal}
        handleClose={closeOpenEditModal}
        width={50}
      >
        <UpdateUser
          handleClose={closeOpenEditModal}
          userDetails={userDetails}
          getUserList={getUserList}
        />
      </IModal>
      <IModal
        open={showDeleteModal}
        // handleOpen={openDeleteModal}
        handleClose={closeDeleteModal}
        width={30}
      >
        <DeleteModal
          handleClose={closeDeleteModal}
          handleSubmit={onHandleDelete}
        />
      </IModal>

    </MainWrapper>
  );
};

export default UserList;
